import React from 'react';
import * as Sentry from '@sentry/react';

const { ENV, VERSION, SENTRY_DSN, DEBUG } = require('../constants').default;

const debug = {};

const getWrapper = () => {
    if (DEBUG || !SENTRY_DSN) {
        return ({ children }) => children; // eslint-disable-line react/prop-types
    }

    Sentry.init({
        dsn: SENTRY_DSN,
        environment: ENV,
        release: VERSION,
        sendDefaultPii: true,
    });

    return ({ children }) => ( // eslint-disable-line react/prop-types
        <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            {children}
        </Sentry.ErrorBoundary>
    );
};

const notify = (message, data) => {
    if (DEBUG || !SENTRY_DSN) {
        return;
    }

    Sentry.withScope((scope) => {
        if (data) {
            Object.entries(data).forEach(([key, value]) => {
                scope.setContext(key, value || {});
            });
        }
        Sentry.captureException(new Error(message));
    });
};

debug.getWrapper = getWrapper;
debug.notify = notify;

export default debug;
